import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../../../core/services/http.service';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ChangeLogModel, ChangeLogSearchModel, ChangeLogSearchResultModel, UserInfoModel } from '../../../../../hub_schema/hubTypes';

@Injectable({
    providedIn: 'root'
})
export class ChangeLogService {
    private httpService: HttpService = inject(HttpService);
    private _components: string[];

    public getHubComponents(): Observable<string[]> {

        if (this._components) {
            return of(this._components);
        }

        const url = environment.endpoints.base + '/changeLog/components';

        return this.httpService.get<string[]>(url).pipe(
            tap((components) => {
                this._components = components;
            })
        );
    }

    public getUsers(projectId: number): Observable<UserInfoModel[]> {
        const url = environment.endpoints.base + '/changeLog/users/' + projectId;
        return this.httpService.get<any[]>(url);
    }

    public searchChangeLog(searchModel: ChangeLogSearchModel): Observable<ChangeLogSearchResultModel> {
        const url = environment.endpoints.base + '/changeLog/search';
        return this.httpService.post<ChangeLogSearchResultModel>(url, searchModel);
    }
}
